import { buildSimpleExportSheet } from './simple-export'

const ejipAllMemberHeader = [
  'Code',
  'Name',
  'Entry Date',
  'Rounds	',
  'Deducted %',
  'Resignation Date	'
]

export function buildEjipAllMemberReportSheet({ data = [] }) {
  return buildSimpleExportSheet({
    header: ejipAllMemberHeader,
    data,
    sheetName: 'MySheet1'
  })
}
